'use client';

import React, { memo } from 'react';
import Image from 'next/image';
import Spinner from '@/components/platform/ui/Spinner';

interface OrganizationIconProps {
  logoUrl?: string | null;
  isActive: boolean;
  isLoading: boolean;
  darkMode: boolean;
  initial: string;
}

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

const OrganizationIcon = memo(function OrganizationIcon({
  logoUrl,
  isActive,
  isLoading,
  darkMode,
  initial,
}: OrganizationIconProps) {
  return (
    <span
      className={classNames(
        isActive
          ? darkMode
            ? 'border-indigo-600 bg-gray-800 text-indigo-400'
            : 'border-indigo-600 bg-white text-indigo-600'
          : darkMode
            ? 'border-gray-700 bg-gray-800 text-gray-300 group-hover:border-indigo-600 group-hover:text-indigo-400'
            : 'border-gray-200 bg-white text-gray-600 group-hover:border-indigo-600 group-hover:text-indigo-600',
        'flex size-6 shrink-0 items-center justify-center overflow-hidden rounded-lg border text-[0.625rem] font-medium'
      )}
    >
      {isLoading ? (
        <Spinner size="xs" darkMode={darkMode} />
      ) : logoUrl ? (
        <Image
          src={logoUrl}
          alt="Organization logo"
          width={24}
          height={24}
          className="size-full object-cover"
        />
      ) : (
        initial
      )}
    </span>
  );
});

export default OrganizationIcon;
